// Copyright © 2021 Move Closer
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 * @author Krzysztof Ustowski <krzysztof.ustowski@movecloser.pl>
 */
export var LabelColor;
(function (LabelColor) {
    LabelColor["Black"] = "black";
    LabelColor["Blue"] = "blue";
    LabelColor["Green"] = "green";
    LabelColor["Red"] = "red";
    LabelColor["White"] = "white";
    LabelColor["Yellow"] = "yellow";
})(LabelColor || (LabelColor = {}));
